import { render, staticRenderFns } from "./KpiOfficeIndex.vue?vue&type=template&id=0ab2e786&scoped=true"
import script from "./KpiOfficeIndex.vue?vue&type=script&lang=js"
export * from "./KpiOfficeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab2e786",
  null
  
)

export default component.exports